"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeResources = void 0;
const resources_1 = require("@opentelemetry/resources");
/* Takes an array of resources and merges into one mega-resource */
function mergeResources(resources) {
    let mergedResources = validateResource(resources[0]);
    for (let i = 1; i < resources.length; i++) {
        if (!resources[i]) {
            continue;
        }
        const resource = validateResource(resources[i]);
        mergedResources = mergedResources.merge(resource);
    }
    return mergedResources;
}
exports.mergeResources = mergeResources;
function validateResource(resource) {
    if (resource instanceof resources_1.Resource) {
        return resource;
    }
    if (resource) {
        return new resources_1.Resource(resource);
    }
    return new resources_1.Resource({});
}
